import * as React from "react";
const SvgSubtract = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#220C4A", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 11L20 11V13L4 13V11Z", fill: "" }));
export default SvgSubtract;
